(() => {
  const CHEVRON = `<svg class="patine-select__arrow" viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg"><polyline points="1 1 6 6 11 1" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

  function enhance(select) {
    const wrapper = document.createElement('div');
    wrapper.className = 'patine-select';
    wrapper.dataset.open = 'false';

    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);
    select.classList.add('patine-select__native');

    const options = Array.from(select.options);
    const selectedOpt = options[select.selectedIndex] || options[0];
    const isPlaceholder = !selectedOpt.value;

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'patine-select__trigger';
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.innerHTML = `<span class="patine-select__value${isPlaceholder ? ' patine-select__value--placeholder' : ''}">${selectedOpt.textContent}</span>${CHEVRON}`;

    const dropdown = document.createElement('ul');
    dropdown.className = 'patine-select__dropdown';
    dropdown.setAttribute('role', 'listbox');

    options.forEach((opt, i) => {
      const li = document.createElement('li');
      li.className = 'patine-select__option';
      li.setAttribute('role', 'option');
      li.setAttribute('data-value', opt.value);
      li.setAttribute('data-index', i);
      li.textContent = opt.textContent;

      if (i === select.selectedIndex) {
        li.classList.add('patine-select__option--selected');
        li.setAttribute('aria-selected', 'true');
      }

      dropdown.appendChild(li);
    });

    wrapper.appendChild(trigger);
    wrapper.appendChild(dropdown);

    let focusedIndex = select.selectedIndex;

    function open() {
      wrapper.dataset.open = 'true';
      trigger.setAttribute('aria-expanded', 'true');
      focusedIndex = select.selectedIndex;
      updateFocus();
    }

    function close() {
      wrapper.dataset.open = 'false';
      trigger.setAttribute('aria-expanded', 'false');
      clearFocus();
    }

    function isOpen() {
      return wrapper.dataset.open === 'true';
    }

    function selectOption(li) {
      const value = li.dataset.value;
      const index = parseInt(li.dataset.index, 10);
      select.selectedIndex = index;
      select.dispatchEvent(new Event('change', { bubbles: true }));

      const valueSpan = trigger.querySelector('.patine-select__value');
      valueSpan.textContent = li.textContent;
      valueSpan.classList.toggle('patine-select__value--placeholder', !value);

      dropdown.querySelectorAll('.patine-select__option').forEach((opt) => {
        opt.classList.remove('patine-select__option--selected');
        opt.removeAttribute('aria-selected');
      });
      li.classList.add('patine-select__option--selected');
      li.setAttribute('aria-selected', 'true');

      close();
    }

    function updateFocus() {
      const items = dropdown.querySelectorAll('.patine-select__option');
      items.forEach((item, i) => {
        item.classList.toggle('patine-select__option--focused', i === focusedIndex);
      });
      if (items[focusedIndex]) {
        items[focusedIndex].scrollIntoView({ block: 'nearest' });
      }
    }

    function clearFocus() {
      dropdown.querySelectorAll('.patine-select__option--focused').forEach((el) => {
        el.classList.remove('patine-select__option--focused');
      });
    }

    trigger.addEventListener('click', () => {
      if (isOpen()) {
        close();
      } else {
        open();
      }
    });

    dropdown.addEventListener('click', (e) => {
      const li = e.target.closest('.patine-select__option');
      if (li) selectOption(li);
    });

    document.addEventListener('click', (e) => {
      if (isOpen() && !wrapper.contains(e.target)) close();
    });

    trigger.addEventListener('keydown', (e) => {
      const items = dropdown.querySelectorAll('.patine-select__option');
      const count = items.length;

      switch (e.key) {
        case 'Escape':
          close();
          trigger.focus();
          e.preventDefault();
          break;
        case 'ArrowDown':
          e.preventDefault();
          if (!isOpen()) {
            open();
          } else {
            focusedIndex = (focusedIndex + 1) % count;
            updateFocus();
          }
          break;
        case 'ArrowUp':
          e.preventDefault();
          if (!isOpen()) {
            open();
          } else {
            focusedIndex = (focusedIndex - 1 + count) % count;
            updateFocus();
          }
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (isOpen() && items[focusedIndex]) {
            selectOption(items[focusedIndex]);
            trigger.focus();
          } else {
            open();
          }
          break;
      }
    });
  }

  function init(root = document) {
    root.querySelectorAll('select.patine-select__native').forEach((sel) => {
      if (!sel.closest('.patine-select')) enhance(sel);
    });
  }

  init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
